import { IState } from '../../store';

export const selectOfferAdded = (state: IState): string => state.offerData.offer.added;
